import React from 'react';
import { Helmet } from 'react-helmet-async';
import Testimonials from '../components/Testimonials';

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://limousine-vip-paris.fr/" },
    { "@type": "ListItem", "position": 2, "name": "Témoignages", "item": "https://limousine-vip-paris.fr/temoignages" }
  ]
};

const aggregateRatingSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://limousine-vip-paris.fr/#business",
  "name": "VIP Limousine Paris",
  "url": "https://limousine-vip-paris.fr/",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": 127,
    "reviewCount": 127
  }
};

const TestimonialsPage = () => {
  return (
    <>
      <Helmet>
        <title>Avis Clients VIP Limousine Paris - Témoignages Vérifiés ★ 4.9/5</title>
        <meta name="description" content="Découvrez les avis vérifiés de nos clients : 127 témoignages, note moyenne 4.9/5. Mariages, transferts aéroport, EVJF, anniversaires à Paris et en Île-de-France." />
        <link rel="canonical" href="https://limousine-vip-paris.fr/temoignages" />
        <meta property="og:title" content="Avis clients VIP Limousine Paris - 4.9/5 sur 127 avis" />
        <meta property="og:description" content="Témoignages vérifiés de nos clients pour mariages, transferts CDG/Orly, EVJF et événements VIP." />
        <meta property="og:url" content="https://limousine-vip-paris.fr/temoignages" />

        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(aggregateRatingSchema)}</script>
      </Helmet>

      <div style={{ paddingTop: '100px' }}>
        <Testimonials />
      </div>
    </>
  );
};

export default TestimonialsPage;
